import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=2140cbc8&"
import script from "./ActivitySummary.vue?vue&type=script&lang=js&"
export * from "./ActivitySummary.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports